import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { CprService } from 'src/app/services/cpr.service';
import { Validator, ValidatorBase } from '../../../+validation/core/model';

@Component({
    selector: 'app-cpr',
    templateUrl: './cpr.component.html',
})
export class CprComponent extends ValidatorBase implements Validator {
    @Input('dob') public dob: string;
    @Input('check') public check: string;

    @Output('onchange')
    public onchange = new EventEmitter();

    @ViewChild('dobInput', { static: false }) private dobInput: ElementRef<HTMLInputElement>;
    @ViewChild('checkInput', { static: false }) private checkInput: ElementRef<HTMLInputElement>;

    private readonly changeDetector: ChangeDetectorRef;
    private readonly cprService: CprService;

    public constructor(
        viewRef: ViewContainerRef,
        changeDetector: ChangeDetectorRef,
        cprService: CprService
    ) {
        super(viewRef);
        this.changeDetector = changeDetector;
        this.cprService = cprService;
    }

    public onDobInput(event: Event, field: 'dob' | 'check'): void {
      const input = event.currentTarget as HTMLInputElement;
      const value = input.value.replace(/\D/g, '');

      if (field === 'dob') {
        this.dob = value;
        input.value = value;
        
        // Automatically move focus to check input when 6 digits are entered
        if (value.length === 6 && this.checkInput) {
          setTimeout(() => this.checkInput.nativeElement.focus(), 0);
        }
      } else if (field === 'check') {
        this.check = value;
        input.value = value;
      }
      
      this.changeDetector.detectChanges();
    }   
    
    public changed(): void {
      if (this.sniff()) {
        this.valid = this.isValid();
        this.onchange.emit();
        this.changeDetector.detectChanges();
      }
    }

    public getCPR(): { dob: string; checkDigits: string } {
        return {
            dob: this.dob,
            checkDigits: this.check,
        };
    }

    protected isValid(): boolean {
        const isValid = this.cprService.valid(this.dob, this.check);
        return isValid;
    }
    public onBlur(): void {
        this.changeDetector.detectChanges();
    }
}
